import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const MartyrsPage = lazy(() => import('../pages/martyrs/page'));
const TimelinePage = lazy(() => import('../pages/timeline/page'));
const MissionaryDetailPage = lazy(() => import('../pages/missionary-detail/page'));
const FaithPioneersPage = lazy(() => import('../pages/faith-pioneers/page'));
const Part1Page = lazy(() => import('../pages/faith-pioneers/part1/page'));
const Part2Page = lazy(() => import('../pages/faith-pioneers/part2/page'));
const Part3Page = lazy(() => import('../pages/faith-pioneers/part3/page'));
const Part4Page = lazy(() => import('../pages/faith-pioneers/part4/page'));
const Part5Page = lazy(() => import('../pages/faith-pioneers/part5/page'));
const Part6Page = lazy(() => import('../pages/faith-pioneers/part6/page'));
const Part7Page = lazy(() => import('../pages/faith-pioneers/part7/page'));
const Part8Page = lazy(() => import('../pages/faith-pioneers/part8/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ShowhostTrainingPage = lazy(() => import('../pages/showhost-training/page'));
const AIDesignClassPage = lazy(() => import('../pages/ai-design-class/page'));
const AIYoutubeShortsPage = lazy(() => import('../pages/ai-youtube-shorts/page'));
const ReaddyHomepagePage = lazy(() => import('../pages/readdy-homepage/page'));
const FilmHumanitiesPage = lazy(() => import('../pages/film-humanities/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/faith-pioneers',
    element: <FaithPioneersPage />,
  },
  {
    path: '/faith-pioneers/part1',
    element: <Part1Page />,
  },
  {
    path: '/faith-pioneers/part2',
    element: <Part2Page />,
  },
  {
    path: '/faith-pioneers/part3',
    element: <Part3Page />,
  },
  {
    path: '/faith-pioneers/part4',
    element: <Part4Page />,
  },
  {
    path: '/faith-pioneers/part5',
    element: <Part5Page />,
  },
  {
    path: '/faith-pioneers/part6',
    element: <Part6Page />,
  },
  {
    path: '/faith-pioneers/part7',
    element: <Part7Page />,
  },
  {
    path: '/faith-pioneers/part8',
    element: <Part8Page />,
  },
  {
    path: '/martyrs',
    element: <MartyrsPage />,
  },
  {
    path: '/missionary-detail/:id',
    element: <MissionaryDetailPage />,
  },
  {
    path: '/timeline',
    element: <TimelinePage />,
  },
  {
    path: '/showhost-training',
    element: <ShowhostTrainingPage />,
  },
  {
    path: '/ai-design-class',
    element: <AIDesignClassPage />,
  },
  {
    path: '/ai-youtube-shorts',
    element: <AIYoutubeShortsPage />,
  },
  {
    path: '/readdy-homepage',
    element: <ReaddyHomepagePage />,
  },
  {
    path: '/film-humanities',
    element: <FilmHumanitiesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
